import type { OrganisationSettings } from 'src/apis/authorization-service/types';
import type { OrganisationSettingsRequest } from 'src/apis/authorization-service/use-organisation-settings';
import { useAxios, type Successful } from 'src/hooks/use-axios';

type ExecuteProps = {
  organisationSettings: Successful<OrganisationSettingsRequest>;
  data: OrganisationSettings;
};

export function useUpdateOrganisationSettings(onError?: (error: any) => void) {
  const request = useAxios(
    (axios, baseConfig, { organisationSettings, data }: ExecuteProps) => {
      const url = organisationSettings.response.data._links.update.href;
      return axios.request<OrganisationSettings>({
        method: 'PUT',
        ...baseConfig,
        url,
        data,
      });
    },
    {
      neededOnPageLoad: false,
      onError,
    }
  );

  return request;
}

export type UpdateOrganisationSettings = ReturnType<
  typeof useUpdateOrganisationSettings
>;
